module.exports = "<mat-chip-list>\n  <mat-chip [ngClass]=\"chipCssClass\">{{status}}</mat-chip>\n</mat-chip-list>\n"